import PropTypes from "prop-types"
import { connect } from "react-redux"
// import { Link } from "react-router-dom"

import { fetchInventory } from "areas/product/store/actions"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import Divider from "components/ui/divider"
import { jewlr_t, isTestMode, IS_JEWLR } from "helpers/application"
import { showHolidayShippingInfoPDP } from "helpers/holiday"

import { ActionBtn } from "./components"
import ShipText from "./ship-text"

const InternalShipDetails = ({
  hasSize,
  showInstantGift,
  showInventoryTable,
  ship,
}) => {
  const RegularView = () => (
    <>
      <ShipText />
      {IS_JEWLR() && sl.config.enable_gift_preview_video && showInstantGift && (
        <Button
          className="text-14 tablet:font-light leading-16 mt-24 font-medium"
          onClick={() => {
            openModal("#gift-preview-video-explained")
            if (!isTestMode) {
              dataLayer.push({
                event: "clicked-need-it-now-pdp",
              })
            }
          }}
          text
          underline
          variant="secondary"
        >
          Need it now? Send a Gift Preview Video
        </Button>
      )}
      {/* <p className="text-14 mt-24">We also offer Buy Online & Pick Up at</p>
      <p className="text-14 font-light">
        5000 Dufferin St Unit Q, North York, ON M3H 5T5
      </p> */}
    </>
  )

  const CertificateView = () => {
    return (
      <>
        <ShipText />
        {sl.config.enable_gift_preview_video && (
          <>
            <div className="py-10">
              <Divider
                className="bg-grey-20 w-(--base-width) desktop:w-(--desktop-width) mx-auto"
                style={{
                  "--base-width": "115px",
                  "--desktop-width": "180px",
                }}
              />
            </div>
            <p className="text-16 tablet:font-bold tracking-tigher leading-16 font-semibold text-black">
              Need it now? <br className="tablet:hidden" />
              We&apos;ve got you with Gift Preview Video
            </p>
            <p
              className="tracking-tigher leading-16 mx-auto mb-10 text-black"
              style={{ maxWidth: "290px" }}
            >
              {showHolidayShippingInfoPDP()
                ? `Order now and share your ${jewlr_t(
                    "terms.personalized"
                  )} video preview
            on ${sl.config.guaranteed_holiday}!`
                : "Send a Gift Preview Video."}
            </p>
            <ActionBtn
              className="tracking-tigher leading-16"
              onClick={() => {
                openModal("#gift-preview-video-explained")
                if (!isTestMode) {
                  dataLayer.push({
                    event: "clicked-need-it-now-pdp",
                  })
                }
              }}
            >
              {showHolidayShippingInfoPDP()
                ? "Learn More"
                : "What is a Gift Preview Video?"}
            </ActionBtn>
          </>
        )}
        {/* <div className="flex justify-center">
          <ActionBtn onClick={() => openModal("#instant-gift-explained")}>
            Instant Gift Video
          </ActionBtn>
          <ActionBtn forwardedAs={Link}
           to="/info/gift_cards">
            E-Gift Card
          </ActionBtn>
        </div> */}
      </>
    )
  }

  // const AvailableHolidayView = () => (
  //   <>
  //     <p className="text-sale tracking-half mb-8 font-bold">
  //       ARRIVES IN TIME FOR {sl.config.guaranteed_holiday.toUpperCase()}
  //     </p>
  //     <ShipText />
  //   </>
  // )

  // LIVE INVENTORY MESSAGING

  // Prompt user to select metal/size
  const InventoryChooseOptionsView = () => (
    <div>
      <ShipText />
      <p className="text-neutral text-14 mb-8 mt-16">
        This item arrives after {sl.config.guaranteed_holiday_alias} in the
        selected metal{hasSize && " and size"}. It is available for{" "}
        {sl.config.guaranteed_holiday_alias} Delivery in other metals
        {hasSize && " and sizes"}.
      </p>
      <ActionBtn onClick={() => showInventoryTable()}>
        See what&apos;s available
      </ActionBtn>
    </div>
  )

  const content = {
    AVAILABLE_HOLIDAY: RegularView,
    CERTIFICATE: CertificateView,
    INVENTORY_CHOOSE_OPTIONS: InventoryChooseOptionsView,
    INVENTORY_UNAVAILABLE: InventoryChooseOptionsView,
    REGULAR: RegularView,
  }

  return <div>{(content[ship.view_type] || content["REGULAR"])()}</div>
}

const mapStateToProps = (state) => {
  const isAccessory = state.wizard.description.product_type === "ACCESSORY"

  return {
    hasSize: !!(state.wizard.data && state.wizard.data.sz),
    ship: state.wizard.shipping.main,
    showInstantGift: !isAccessory,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showInventoryTable: () => {
      openModal("#inventory")
      dispatch(fetchInventory())
    },
    // toggleCertificateModal: () => openModal("#certificate"),
  }
}

InternalShipDetails.propTypes = {
  hasSize: PropTypes.bool,
  ship: PropTypes.object,
  showInstantGift: PropTypes.bool,
  showInventoryTable: PropTypes.func,
  // toggleCertificateModal: PropTypes.func,
}

const ShipDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalShipDetails)

export default ShipDetails
